module.exports = __webpack_public_path__ + "media/images/logo-a3ddd0ca.jpg";